.footer {
  display: flex;
  min-height: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 1.5rem;
  background-color: var(--footer-bg-color);
  grid-area: footer;
}

.footerText {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0.5rem 0 1rem 0;
}

.footerTextBottom {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 2rem;
}

.footerContact {
  margin-top: 1.5rem;
}

.footerAddress {
  display: flex;
  flex-direction: column;
}

.footerDivider {
  height: 1px;
  width: 80%;
  margin: 0.5rem 0;
  border-top: 1px solid #d2d2d7;
}

@media (max-width: 767.98px) {
  .footerText {
    width: 100%;
  }

  .footerDivider {
    width: 100%;
  }
}
